var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("vx-card", { staticClass: "mb-4" }, [
        _c("h4", { staticClass: "mb-1" }, [
          _vm._v(_vm._s(_vm.$t("settlement.title"))),
        ]),
        _c("small", { staticClass: "text-muted d-block" }, [
          _vm._v(_vm._s(_vm.$t("settlement.hint"))),
        ]),
        _c(
          "div",
          { staticClass: "mt-2 flex items-center gap-2" },
          [
            _c("b-form-select", {
              staticStyle: { width: "220px" },
              attrs: { options: _vm.statusFilters, size: "sm" },
              on: { change: _vm.load },
              model: {
                value: _vm.filterStatus,
                callback: function ($$v) {
                  _vm.filterStatus = $$v
                },
                expression: "filterStatus",
              },
            }),
            _vm.openTotalCents > 0
              ? _c("span", { staticClass: "text-danger" }, [
                  _vm._v(" " + _vm._s(_vm.$t("settlement.open_total")) + ": "),
                  _c("strong", [_vm._v(_vm._s(_vm.money(_vm.openTotalCents)))]),
                ])
              : _vm._e(),
          ],
          1
        ),
      ]),
      _c("vx-card", [
        _vm.isLoading
          ? _c("div", { staticClass: "text-center py-4 text-muted" }, [
              _vm._v(_vm._s(_vm.$t("common.loading"))),
            ])
          : !_vm.rows.length
          ? _c(
              "div",
              { staticClass: "text-center py-4" },
              [
                _c("feather-icon", {
                  staticClass: "h-8 w-8 text-success mb-1",
                  attrs: { icon: "CheckCircleIcon" },
                }),
                _c("p", { staticClass: "text-muted mb-0" }, [
                  _vm._v(_vm._s(_vm.$t("settlement.empty"))),
                ]),
              ],
              1
            )
          : _c("table", { staticClass: "w-full admin-table" }, [
              _c("thead", [
                _c("tr", [
                  _c("th", [_vm._v("ID")]),
                  _c("th", [_vm._v(_vm._s(_vm.$t("settlement.legal_entity")))]),
                  _c("th", [_vm._v(_vm._s(_vm.$t("commission.order")))]),
                  _c("th", { staticClass: "text-right" }, [
                    _vm._v(_vm._s(_vm.$t("settlement.amount"))),
                  ]),
                  _c("th", [_vm._v(_vm._s(_vm.$t("status")))]),
                  _c("th"),
                ]),
              ]),
              _c(
                "tbody",
                _vm._l(_vm.rows, function (s) {
                  return _c("tr", { key: s.id }, [
                    _c("td", [_vm._v(_vm._s(s.id))]),
                    _c("td", [
                      _vm._v(
                        _vm._s(
                          _vm._.get(s, "legal_entity.name") ||
                            "#" + s.legal_entity_id
                        )
                      ),
                    ]),
                    _c("td", [_vm._v("#" + _vm._s(s.order_id))]),
                    _c("td", { staticClass: "text-right" }, [
                      _c("strong", [_vm._v(_vm._s(_vm.money(s.amount_cents)))]),
                    ]),
                    _c(
                      "td",
                      [
                        _c(
                          "vs-chip",
                          {
                            attrs: {
                              transparent: "",
                              color:
                                s.status === "PG"
                                  ? "success"
                                  : s.status === "CA"
                                  ? "dark"
                                  : "warning",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("settlement.status_." + s.status)
                                ) +
                                " "
                            ),
                          ]
                        ),
                        s.external_reference
                          ? _c("small", { staticClass: "text-muted d-block" }, [
                              _vm._v(_vm._s(s.external_reference)),
                            ])
                          : _vm._e(),
                      ],
                      1
                    ),
                    _c(
                      "td",
                      { staticClass: "text-right" },
                      [
                        s.status === "OP"
                          ? _c(
                              "b-button",
                              {
                                directives: [
                                  {
                                    name: "permission",
                                    rawName: "v-permission",
                                    value: "wallet_settlements.settle",
                                    expression: "'wallet_settlements.settle'",
                                  },
                                ],
                                attrs: { size: "sm", variant: "primary" },
                                on: {
                                  click: function ($event) {
                                    return _vm.settle(s)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("settlement.settle")) +
                                    " "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ])
                }),
                0
              ),
            ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }